import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { FONT_FAMILY_SCHEMA, getFontFamily } from '../fonts';
import { getPadding, PADDING_SCHEMA } from '../padding';
import EmailMarkdown from './EmailMarkdown';
export const TextPropsSchema = z.object({
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        fontSize: z.number().gte(0).optional().nullable(),
        fontFamily: FONT_FAMILY_SCHEMA,
        fontWeight: z.enum(['bold', 'normal']).optional().nullable(),
        textAlign: z.enum(['left', 'center', 'right']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        markdown: z.boolean().optional().nullable(),
        text: z.string().optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Text({ style, props }) {
    var _e, _t, _y, _10, _11;
    const wStyle = {
        color: (_e = style === null || style === void 0 ? void 0 : style.color) !== null && _e !== void 0 ? _e : undefined,
        backgroundColor: (_t = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _t !== void 0 ? _t : undefined,
        fontSize: (_y = style === null || style === void 0 ? void 0 : style.fontSize) !== null && _y !== void 0 ? _y : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_10 = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _10 !== void 0 ? _10 : undefined,
        textAlign: (_11 = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _11 !== void 0 ? _11 : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    const text = props === null || props === void 0 ? void 0 : props.text;
    if (props === null || props === void 0 ? void 0 : props.markdown) {
        return React.createElement(EmailMarkdown, { style: wStyle, markdown: text });
    }
    return React.createElement("div", { style: wStyle }, text);
}
//# sourceMappingURL=Text.js.map